export default {
  'exportRecords.title': '导出记录',
  'exportRecords.form.taskType': '导出类型',
  'exportRecords.form.taskType.placeholder': '请选择导出类型',
  'exportRecords.form.status': '状态',
  'exportRecords.form.status.placeholder': '请选择状态',
  'exportRecords.form.search': '查询',
  'exportRecords.form.reset': '重置',
  'exportRecords.type.orders': '订单列表',
  'exportRecords.type.subscription-orders': '订阅订单列表',
  'exportRecords.type.subscription': '订阅记录',
  'exportRecords.status.pending': '排队中',
  'exportRecords.status.processing': '导出中',
  'exportRecords.status.success': '已完成',
  'exportRecords.status.failed': '失败',
  'exportRecords.columns.index': '#',
  'exportRecords.columns.fileName': '文件名',
  'exportRecords.columns.taskType': '导出类型',
  'exportRecords.columns.status': '状态',
  'exportRecords.columns.progress': '进度',
  'exportRecords.columns.totalRows': '数据行数',
  'exportRecords.columns.createdAt': '创建时间',
  'exportRecords.columns.finishedAt': '完成时间',
  'exportRecords.columns.operations': '操作',
  'exportRecords.operations.download': '下载',
  'exportRecords.operations.downloadStarted': '开始下载',
  'exportRecords.operations.unavailable': '文件不可用',
  'exportRecords.operations.delete': '删除',
  'exportRecords.operations.deleteConfirm': '确认删除该导出记录？删除后不可恢复。',
  'exportRecords.operations.deleteSuccess': '删除成功',
  'exportRecords.operations.deleteError': '删除失败',
  'exportRecords.operations.deleteMissingId': '缺少任务 ID，无法删除',
  'exportRecords.operations.deleteMissingType': '缺少导出类型，无法删除',
  'exportRecords.operations.batchDelete': '批量删除',
  'exportRecords.operations.batchDeleteConfirm':
    '确认删除选中的导出记录？删除后不可恢复。',
  'exportRecords.operations.batchDeleteEmpty': '请先选择要删除的记录',
  'exportRecords.operations.batchDeleteSuccess': '批量删除成功',
  'exportRecords.operations.loadError': '加载导出记录失败',
  'exportRecords.empty': '暂无导出记录',
};
